import {Model} from './model';
import {EventEmitter} from '@angular/core';
import {environment} from '../../environments/environment';

export class User extends Model {
  static readonly login$ = new EventEmitter();
  static readonly logout$ = new EventEmitter();

  public _id: string;
  public name: string;
  public email: string;
  public token: string;
  public role: string;
  public created_at: string;

  get attributeMap(): { [p: string]: any } {
    return {
      _id: String,
      name: String,
      email: String,
      token: String,
      role: String,
      created_at: String,
    };
  }

  public static deleteFromLS(): void {
    return localStorage.removeItem('user');
  }

  public static logout(): void {
    this.deleteFromLS();
    User.logout$.emit();
  }

  public static getFromLS(): User {
    const userJSON = localStorage.getItem('user');
    if (userJSON) {
      return new User(JSON.parse(userJSON));
    }
    return null;
  }

  public static getTokenFromLS(): string {
    const userJSON = localStorage.getItem('user');
    if (userJSON) {
      const user = JSON.parse(userJSON);
      return user.token;
    }

    return null;
  }

  public static setToLS(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
    this.login$.emit(user);
  }

  public static guest(): boolean {
    return localStorage.getItem('user') == null;
  }

  public static is(role: string): boolean {
    return User.guest() ? false : User.getFromLS().is(role);
  }


  public static isAnyOf(roles: string[]) {
    return User.guest() ? false : roles.indexOf(User.getFromLS().role) !== -1;
  }

  public static defaultRedirectTo(): string[] {
    if (User.guest()) {
      return ['/login'];
    }
    switch (User.getFromLS().role) {
      default:
        return ['/events'];
    }
  }

  public static id() {
    const user = User.getFromLS();
    return user ? user._id : null;
  }

  public is(role: string): boolean {
    return this.role === role;
  }

}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/models/user.model.ts